// Repairs "mojibake" — UTF-8 text that was mistakenly decoded as Windows-1252,
// turning characters like — ' " into sequences like â€" â€™ â€œ.
const WIN1252 = {
  0x20ac: 0x80, 0x201a: 0x82, 0x0192: 0x83, 0x201e: 0x84, 0x2026: 0x85,
  0x2020: 0x86, 0x2021: 0x87, 0x02c6: 0x88, 0x2030: 0x89, 0x0160: 0x8a,
  0x2039: 0x8b, 0x0152: 0x8c, 0x017d: 0x8e, 0x2018: 0x91, 0x2019: 0x92,
  0x201c: 0x93, 0x201d: 0x94, 0x2022: 0x95, 0x2013: 0x96, 0x2014: 0x97,
  0x02dc: 0x98, 0x2122: 0x99, 0x0161: 0x9a, 0x203a: 0x9b, 0x0153: 0x9c,
  0x017e: 0x9e, 0x0178: 0x9f,
};

const decoder = new TextDecoder("utf-8", { fatal: true });

/** Fix a single string. Returns it unchanged if it isn't mojibake. */
export function fixMojibake(str) {
  if (typeof str !== "string" || !str) return str;

  // Fast exit: genuine mojibake always contains Â (U+00C2), Ã (U+00C3),
  // or â (U+00E2). No such char => almost certainly clean, skip the work.
  if (!/[\u00c2\u00c3\u00e2]/.test(str)) return str;

  try {
    const bytes = Uint8Array.from(
      [...str].map((c) => {
        const cp = c.charCodeAt(0);
        return WIN1252[cp] ?? (cp & 0xff);
      }),
    );
    // fatal:true throws on invalid UTF-8, so clean-but-accented text
    // (a real é, etc.) falls through to the catch and is returned as-is.
    return decoder.decode(bytes);
  } catch {
    return str;
  }
}

/** Recursively fix every string inside an object/array. */
export function deepFixMojibake(value) {
  if (typeof value === "string") return fixMojibake(value);
  if (Array.isArray(value)) return value.map(deepFixMojibake);
  if (value && typeof value === "object") {
    const out = {};
    for (const key of Object.keys(value)) {
      out[key] = deepFixMojibake(value[key]);
    }
    return out;
  }
  return value; // numbers, booleans, null, undefined — untouched
}